import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, radius, themeMode, variant, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import Button from '../Button/Button.es.js';
import { Heading } from '../Heading/Heading.es.js';
var Wrapper = styled(Box).withConfig({
  componentId: "sc-198krwy-0"
})(["display:flex;flex-direction:column;padding:0;"]);
var Title = styled(Heading).withConfig({
  componentId: "sc-198krwy-1"
})(["margin-bottom:0;"]);
var Cta = styled(Button).attrs(function () {
  return {
    kind: "link",
    size: "sm"
  };
}).withConfig({
  componentId: "sc-198krwy-2"
})(["margin-right:", ";&:last-child{margin-right:0;}"], spacing("sm"));
var ActionGroup = styled(Box).withConfig({
  componentId: "sc-198krwy-3"
})(["display:flex;align-items:center;justify-content:flex-start;margin-top:", ";"], spacing("xs"));
var messageVariants = variant({
  prop: "variant",
  variants: {
    default: {
      backgroundColor: themeMode({
        light: "rgba(108, 119, 130, 0.1)",
        dark: "neutral.800"
      })
    },
    subtle: {
      backgroundColor: "transparent",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: themeMode({
        light: "neutral.200",
        dark: "neutral.700"
      })
    },
    contrast: {
      backgroundColor: themeMode({
        light: "rgba(50, 203, 203, 0.1)",
        dark: "neutral.800"
      })
    },
    success: {
      backgroundColor: themeMode({
        light: "rgba(50, 203, 203, 0.1)",
        dark: "neutral.800"
      })
    },
    warning: {
      backgroundColor: themeMode({
        light: "rgba(238, 194, 0, 0.1)",
        dark: "neutral.800"
      })
    },
    danger: {
      backgroundColor: themeMode({
        light: "rgba(225, 21, 52, 0.1)",
        dark: "neutral.800"
      })
    }
  }
});
var messageKinds = variant({
  prop: "kind",
  variants: {
    default: {},
    inline: {
      display: "inline-flex",
      padding: 0,
      border: "none",
      backgroundColor: "transparent"
    }
  }
});
var Message = styled(Box).withConfig({
  componentId: "sc-198krwy-4"
})(["display:flex;align-items:flex-start;width:100%;padding:", ";border-radius:", ";color:", ";", ";", ";"], spacing("lg"), radius("base"), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), messageVariants, messageKinds);
var iconVariants = variant({
  prop: "variant",
  variants: {
    default: {
      color: "neutral.500"
    },
    subtle: {
      color: "neutral.500"
    },
    contrast: {
      color: "success.500"
    },
    success: {
      color: "success.500"
    },
    warning: {
      color: "warning.500"
    },
    danger: {
      color: "danger.500"
    }
  }
});
var IconWrapper = styled(Box).withConfig({
  componentId: "sc-198krwy-5"
})(["display:inline-flex;flex:0 0 auto;align-items:center;margin-right:", ";", ";"], spacing("sm"), iconVariants);
export { ActionGroup, Cta, IconWrapper, Message, Title, Wrapper };